import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from '../constants/actionTypes'
import {
  CreateTicketModal,
  Props as CreateTicketModalProps,
} from '../components/createTicketModal'
import {
  ResolveConvModal,
  Props as ResolveConvModalProps,
} from '../components/resolveConvModal'
import { AnalyticsModal } from '../components/analyticsModal'
import { hideModal } from '../actions/modalsActions'
import { submitCreateTicket } from '../actions/createTicketActions'
import { submitResolveConv } from '../actions/resolveConvActions'

export interface Props {
  currentModal: string
}

export class ModalSelectorView extends Component<Props> {
  static displayName = 'ModalSelector'

  render() {
    const { currentModal, ...rest } = this.props

    switch (currentModal) {
      case actions.ShowCreateTicket:
        return (
          <CreateTicketModal {...(rest as unknown as CreateTicketModalProps)} />
        ) // TODO-TS oof
      case actions.ShowResolveConv:
        return (
          <ResolveConvModal {...(rest as unknown as ResolveConvModalProps)} />
        ) // TODO-TS oof
      case actions.ShowAnalyticsModal:
        return <AnalyticsModal />
      default:
        return null
    }
  }
}

const mapStateToProps = (store) => {
  const { modals, currentConv } = store
  return {
    currentModal: modals.currentModal,
    currentConv,
  }
}

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal()),
  submitCreateTicket: (currentConv, ticket) =>
    dispatch(submitCreateTicket(currentConv, ticket)),
  submitResolveConv: (id) => dispatch(submitResolveConv(id)),
})

export const ModalSelector = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalSelectorView)
